export const prepareTime = (time: string | null | undefined): string | null => {
  if (!time || !time?.trim()) return null;

  const parts = time.split(':');
  if (parts.length < 2) return null;

  const [hh, mm] = parts;
  return `${hh}:${mm}`;
};
